var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-button",style:(_vm.styleVariables)},[_c('label',[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"input":_vm.input}}),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }